import React, { useState, useEffect } from 'react';
import { getTableBd, ordenarArreglo } from '../../../config/functions';
import { LoaderES } from '../../LoaderES';
import { Filtrar } from '../../Filtrar';
import { Pagination } from '../../Pagination';
import { ModalOperEdit } from './ModalOperEdit';

const Operadoras = ({ 
  broken, collapsed, mobile, user, colors,
  // Tab props (solo desktop)
  openTabs, setOpenTabs, activeTabId, setActiveTabId, showRigSelector, setShowRigSelector, theme
}) => {

  const [operadoras, setOperadoras] = useState([]);
  const [documentosFiltrados, setDocumentosFiltrados] = useState([]);
  const [operadora, setOperadora] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [open, setOpen] = useState(null);
  const [registrosPorPagina, setRegistrosPorPagina] = useState(15);
  const [paginaActual, setPaginaActual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(0)
  const [registrosPaginaActual, setRegistrosPaginaActual] = useState([])

  const [tipo, setTipo] = useState('')

  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const [filtro, setFiltro] = useState(''); // Estado elevado del filtro

  //----------------------------------------------

  const getOperadoras = async () => {
    setIsLoading(true)
    try {
      const data = await getTableBd('getoperadoras')
      if (data.length === 0) {
        setIsLoading(false)
        setOperadoras([])
        return
      }
      setOperadoras(data)
    } catch (error) {
      console.error('Error al obtener los datos:', error);
    } finally {
      setIsLoading(false)
    }
  }

  //---------------------------------------------

  useEffect(() => { getOperadoras() }, [])
  useEffect(() => { setDocumentosFiltrados(operadoras) }, [operadoras])

  //---------------------------------------------

  useEffect(() => {
    const newTotalPaginas = Math.ceil(documentosFiltrados.length / registrosPorPagina)
    setTotalPaginas(newTotalPaginas)
    
    // Ajustar paginaActual si está fuera de rango después de actualizar
    if (paginaActual > newTotalPaginas && newTotalPaginas > 0) {
      setPaginaActual(newTotalPaginas)
    }
  }, [documentosFiltrados, registrosPorPagina])

  useEffect(() => {
    const inicio = (paginaActual - 1) * parseInt(registrosPorPagina)
    const fin = inicio + parseInt(registrosPorPagina)
    setRegistrosPaginaActual(documentosFiltrados.slice(inicio, fin))
  }, [paginaActual, totalPaginas, documentosFiltrados])

  //---------------------------------------------

  return (
    <>
      {(isLoading)
        ? <LoaderES />
        : <>
          <Filtrar
            documentos={operadoras}
            setDocumentosFiltrados={setDocumentosFiltrados}
            setRegistrosFiltrados={setRegistrosPaginaActual}
            registrosPorPagina={registrosPorPagina}
            filtro={filtro}
            setFiltro={setFiltro}
            colors={colors} />

          <div className="table-responsive mt-3">
            <table className="table table-hover table-sm align-middle table-bordered" id='myTable'
              style={{ color: colors.colorFont || '#000000' }}>
              <thead>
                <tr>
                  <th scope="col" ></th>
                  <th scope="col" >Id &nbsp;&nbsp;
                    <i className="fa-solid fa-arrow-down-1-9"
                      onClick={() => ordenarArreglo('id', operadoras, setOperadoras)}
                      style={{ cursor: "pointer", color: colors.colorFont || '#000000' }} />
                  </th>
                  <th scope="col" >Operadora &nbsp;&nbsp;
                    <i className="fa-solid fa-arrow-down-a-z"
                      onClick={() => ordenarArreglo('operadora', operadoras, setOperadoras)}
                      /* onClick={() => ordenar(2)} */
                      style={{ cursor: "pointer" }} />
                  </th>
                </tr>
              </thead>
              <tbody>
                {operadoras && operadoras.length > 0
                  ? registrosPaginaActual.map(oper => (
                    <tr key={oper.nb_var_idn} style={{ fontSize: '11px' }}>
                      <td>
                        <button className='btn btn-sm fa-solid fa-pencil'
                          onClick={() => {
                            setTipo('editar')
                            setOperadora(oper)
                            setShowModal(true)
                          }}
                          style={{ color: colors.colorFont || '#000000' }}
                        >
                        </button>
                      </td>
                      <td scope="row">{oper.id}</td>
                      <td>{oper.operadora}</td>
                    </tr>
                  ))
                  : null
                }
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3">
                    <button className='btn btn-primary btn-sm fa-solid fa-plus'
                      onClick={() => {
                        setTipo('nuevo')
                        setOperadora('')
                        setShowModal(true)
                      }} />
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>


          <Pagination
            paginaActual={paginaActual}
            totalPaginas={totalPaginas}
            setPaginaActual={setPaginaActual}
            registrosPorPagina={registrosPorPagina}
            setRegistrosPorPagina={setRegistrosPorPagina}
            documentosFiltrados={documentosFiltrados}
            broken={broken}
            collapsed={collapsed}
            mobile={mobile}
            colors={colors}
          />

          <ModalOperEdit
            operadoraAll={operadora}
            show={showModal}
            setIsLoading={setIsLoading}
            handleClose={handleCloseModal}
            setOperadoras={setOperadoras}
            user={user}
            getOperadoras={getOperadoras}
            tipo={tipo}
          />

        </>
      }
    </>
  )
}

export default Operadoras
